import ConfirmationModalContainer from './containers/ConfirmationModalContainer'

export default ConfirmationModalContainer
